import React, { useEffect } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  message: string;
  type: ToastType;
  onClose: () => void;
  duration?: number;
  action?: string;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, duration = 3000, action }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const colors = {
    success: { bg: '#28a745', icon: '✓' },
    error: { bg: '#dc3545', icon: '✕' },
    info: { bg: '#17a2b8', icon: 'ℹ' },
    warning: { bg: '#ffc107', icon: '⚠' },
  };

  const { bg, icon } = colors[type];

  return (
    <div
      style={{
        position: 'fixed',
        top: '100px',
        right: '20px',
        background: bg,
        color: '#fff',
        padding: '1rem 1.5rem',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        zIndex: 9999,
        animation: 'slideIn 0.3s ease',
        maxWidth: '400px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span style={{ fontSize: '1.2rem' }}>{icon}</span>
        <span style={{ flex: 1 }}>{message}</span>
        <button
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '1.2rem',
            padding: 0,
          }}
        >
          ×
        </button>
      </div>
      {action && (
        <div
          style={{
            fontSize: '0.85rem',
            opacity: 0.9,
            paddingLeft: '1.7rem',
          }}
        >
          {action}
        </div>
      )}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Toast;
